import * as React from 'react';
import range from 'lodash/range';
import {useDispatch} from 'react-redux';

import {
  WritebackContext,
  UPDATE_QUESTION,
} from 'src/components/writeback/writeback-wrapper';
import Input from 'src/components/lib/error-input/index';
import Select from 'src/components/lib/select/select';

import moduleCss from 'src/components/workflow/event/content/module/editors/module.css';


export default ({
  conditionalAlerts,
  error,
}: {
  conditionalAlerts?: boolean;
  error: {
    question?: {
      errors: string[];
    };
    minText?: {
      errors: string[];
    };
    maxText?: {
      errors: string[];
    };
  };
}): React.ReactElement<React.ComponentProps<'div'>> => {
  const {state, dispatch} = React.useContext(WritebackContext);
  const currentQuestionType = state.question?.selectedType;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'QuestionType' can't be used to index type 'CurrentQuestion'.
  const currentQuestion = state.question?.[currentQuestionType];
  const reduxStoreDispatcher = useDispatch();

  return (
    <div className={moduleCss.ratingScaleContainer}>
      <div className={moduleCss.ratingScaleModule_bottomContent}>
        <label
          className={moduleCss.generalModule_questionLabel}
          data-qa-id="rating-scale-left-label"
        >
          <div
            className={moduleCss.labelWithInlineSelector}
          >{`Left Label (${currentQuestion.minRating})`}</div>
          {/* @ts-expect-error - TS2786 - 'Input' cannot be used as a JSX component. */}
          <Input
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            className={moduleCss.generalModule_input}
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            type="text"
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            placeholder="e.g. Not Good"
            // @ts-expect-error - TS2322 - Type 'any' is not assignable to type 'never'.
            value={currentQuestion.minText}
            // @ts-expect-error - TS2322 - Type '(event: any) => void' is not assignable to type 'never'. | TS7006 - Parameter 'event' implicitly has an 'any' type.
            onChange={(event) => {
              dispatch({
                type: UPDATE_QUESTION,
                payload: {
                  questionType: currentQuestionType,
                  // @ts-expect-error - TS2322 - Type '{ minText: any; }' is not assignable to type 'Question'.
                  attrs: {
                    minText: event.target.value,
                  },
                },
              });
            }}
            // @ts-expect-error - TS2322 - Type 'string[] | undefined' is not assignable to type 'never'.
            errors={error?.minText?.errors}
          />
        </label>
        <div className={moduleCss.ratingScaleModule_separator} />
        <label
          className={moduleCss.generalModule_questionLabel}
          data-qa-id="rating-scale-right-label"
        >
          <div
            className={moduleCss.labelWithInlineSelector}
          >{`Right Label (${currentQuestion.maxRating})`}</div>
          {/* @ts-expect-error - TS2786 - 'Input' cannot be used as a JSX component. */}
          <Input
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            className={moduleCss.generalModule_input}
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            type="text"
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
            placeholder="e.g. Great"
            // @ts-expect-error - TS2322 - Type 'any' is not assignable to type 'never'.
            value={currentQuestion.maxText}
            // @ts-expect-error - TS2322 - Type '(event: any) => void' is not assignable to type 'never'. | TS7006 - Parameter 'event' implicitly has an 'any' type.
            onChange={(event) => {
              dispatch({
                type: UPDATE_QUESTION,
                payload: {
                  questionType: currentQuestionType,
                  // @ts-expect-error - TS2322 - Type '{ maxText: any; }' is not assignable to type 'Question'.
                  attrs: {
                    maxText: event.target.value,
                  },
                },
              });
            }}
            // @ts-expect-error - TS2322 - Type 'string[] | undefined' is not assignable to type 'never'.
            errors={error?.maxText?.errors}
          />
        </label>
      </div>
      <div className={moduleCss.generalModule_row}>
        {conditionalAlerts && (
          <div className={moduleCss.ratingScaleModule_alertRating}>
            <div className={moduleCss.ratingScaleModule_alertRatingTitle}>
              Send alert if answer is:{' '}
            </div>
            <div
              className={
                moduleCss.ratingScaleModule_alertRatingSelect_container
              }
            >
              {/* @ts-expect-error - TS2769 - No overload matches this call. */}
              <Select
                className={moduleCss.ratingScaleModule_alertRatingSelect}
                value={currentQuestion.alertRating}
                options={range(
                  currentQuestion.minRating,
                  currentQuestion.maxRating + 1,
                ).map((value) => ({
                  label: `<= ${value}`,
                  value,
                }))}
                onChange={(evt) => {
                  dispatch({
                    type: UPDATE_QUESTION,
                    payload: {
                      questionType: currentQuestionType,
                      // @ts-expect-error - TS2322 - Type '{ alertRating: number | undefined; }' is not assignable to type 'Question'.
                      attrs: {
                        alertRating: evt?.value,
                      },
                    },
                  });
                }}
                clearable={false}
                searchable={false}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
